import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel, { CarouselItem } from '../Carousel';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IGalleryCarouselProps extends IBaseElementProps {
	galleryItems?: IImage[];
	/**
	 * Enable Banner Autoplay
	 */
	enableAutoplay?: boolean;
	/**
	 * Banner Carousel Auto Play Speed in Milliseconds
	 */
	autoplayDuration?: string;
}

/**
 * Rotating Hero Banner
 * @block
 * @requiresHooks
 * @icon format-image
 */
const GalleryCarousel: React.FC<IGalleryCarouselProps> = ({
	className,
	classNames = [],
	galleryItems = [],
	enableAutoplay = false,
	autoplayDuration,
}) => {
	const carouselOptions: any = {};

	if (enableAutoplay) {
		carouselOptions.autoplay = autoplayDuration;
	}

	return (
		<Carousel
			options={carouselOptions}
			className={className || cn('gallery', ...classNames)}
		>
			{galleryItems.length > 0 &&
				galleryItems.map((galleryItem, i) => (
					<CarouselItem key={i}>
						<div className={cn('gallery__wrapper')}>
							<Image
								{...galleryItem}
								className={cn('gallery__image')}
							/>
						</div>
					</CarouselItem>
				))}
		</Carousel>
	);
};

export default GalleryCarousel;
